import {Component, OnInit, OnDestroy,  ViewChild } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ConfigurationService } from '../../services/configuration.service';
import { GeoLocationService } from '../../services/geo-location.service';
import { ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TranslatesService } from './../../services/translates.service';
import { QuestionsService } from './../../services/questions.service';
import { HaversineService, GeoCoord } from 'ng2-haversine';
import { BrowserModule, Title } from '@angular/platform-browser';

declare var $: any;

@Component({
    selector: 'app-trip-map',
    templateUrl: './trip-map.component.html',
    styleUrls: ['./trip-map.component.scss']
})
export class TripMapComponent implements OnInit, OnDestroy {

    show = false;

    deviceInfo = null;
    isMobile = null;
    isDevice = null;
    isMobileDevice = null;
    public score = 0;
    titleIndex = 'trip-page-title';

    public tripId: number;
    public tripData = { };
    public knowLocation = false;
    private distanceInterval: any;

    public audioPlaying = false;
    private subscriptions: any;
    public modalPlaceShown = false;
    public geolocationPosition = {
        coords: {
            latitude: undefined,
            longitude: undefined
        }
    };
    public geolocationOnce = {
        coords: {
            latitude: undefined,
            longitude: undefined
        }
    };
    public currentGeoLocation = {
        coords: {
            latitude: undefined,
            longitude: undefined
        }
    };
    public places = [];
    public waypoints = [];
    public origin = null;
    public destination = null;
    public distance = 9999;
    public isNearPoint = false;
    public isRouteVisible = false;
    // directions options:
    public renderOptions = {suppressMarkers: true, draggable: false};
    public renderOptionsCurrentStart = {suppressMarkers: true, draggable: false};
    public travelMode = 'WALKING';

    public activePoint = {
        audio: '',
        description: '',
        icon: '../../../assets/images/nysa/1.1.png',
        id: 1,
        lat: 50.474468,
        lng: 17.334514,
        location: {lat: 53.678418, lng: 9.809007},
        pano_url: 'panorama/p-022.html',
        photo_url: '../../../assets/images/nysa/herb_nysa.png',
        title: 'tytuł 1',
        trip_id: 1
    };

    @ViewChild('objectAudio') objectAudio: any;

    public checkIsQuestionAnswered() {
        if (this.questionsService.data[this.activePoint.id] !== undefined && this.questionsService.data[this.activePoint.id] !== null) {
            if (this.questionsService.data[this.activePoint.id].answerId !== null) {
            return true;
            }
        }
        return false;
    }

    public isAnswerGood() {
        if (this.questionsService.data[this.activePoint.id] !== undefined && this.questionsService.data[this.activePoint.id] !== null) {
            if (this.questionsService.data[this.activePoint.id].answerId !== null) {
            return this.questionsService.data[this.activePoint.id].good === true ? true : false;
            }
        }
        return false;
    }

  private generateWaypoints() {
    this.origin = this.places[0].location;
    this.destination = this.places[this.places.length - 1].location;

        for (const place in this.places) {
            if (+place !== 0 && +place < this.places.length - 1) {
                this.waypoints.push(this.places[place].waypoint);
            }
        }
    }

    showModalPlace(point) {
        this.activePoint = point;
        this.modalPlaceShown = true;
        // console.log('POINT:', point);
        if (this.isMobileDevice) {
            this.isUserNearPoint(point);
            this.distanceInterval = setInterval(
                () => {
                    this.isUserNearPoint(point);
                },
                5000
            );
        }
    }
    public isUserNearPoint(point) {
        this.tryHaversine(point);
        if (this.distance < 300)  {  // 300m
            this.isNearPoint = true;
            // console.log('UŻYTKOWNIK BLISKO OBIEKTU');
        } else {
            this.isNearPoint = false;
        }
    }
    public hideModalPlace() {
        const nativeAudio = this.objectAudio.nativeElement;
        nativeAudio.currentTime = 0;
        nativeAudio.pause();
        this.audioPlaying = false;
        this.modalPlaceShown = false;
        clearInterval(this.distanceInterval);
    }
    public tryHaversine(start) {
        const convertedStart: GeoCoord = {
            latitude: start.lat,
            longitude: start.lng
        };
        // console.log('Coords in harvesine method: ', this.currentGeoLocation.coords);
        this.distance = this._haversineService.getDistanceInMeters(this.currentGeoLocation.coords, convertedStart);
        /*console.log(`
        The distance between current location and clicked place is:
            - ${this.distance} meters`);*/
        return this.distance;
    }

    constructor(
        private apiService: ApiService,
        public configurationService: ConfigurationService,
        public geoLocationService: GeoLocationService,
        private deviceService: DeviceDetectorService,
        private questionsService: QuestionsService,
        public translate: TranslatesService,
        private route: ActivatedRoute,
        private _haversineService: HaversineService,
        private titleService: Title
    ) {
        this.checkDevice();
    }

    ngOnInit() {
        this.titleService.setTitle(this.translate.getText(this.titleIndex));
        this.subscriptions = this.route.params.subscribe(params => {
            this.tripId = +params['id']; // (+) converts string 'id' to a number
            this.getObjectsTrip(this.tripId);
            this.getTripData(this.tripId);
        });
        if (this.isMobileDevice) {
            this.getCurrentLocation();
        }

        /*this.tryHaversine();*/
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }



    public getCurrentLocation() {
        this.geoLocationService.startWatching() ;
        this.geoLocationService.location.subscribe(position =>  {
            this.geolocationPosition = position;
            /*console.log('Current position:' + this.geolocationPosition);*/
           /* console.log('geolocationonce :', this.geolocationOnce);*/
            if (this.geolocationPosition != null) {
                if (typeof this.geolocationPosition.coords !== 'undefined') {
                    if (typeof this.geolocationPosition.coords.latitude !== 'undefined') {

                        this.currentGeoLocation = this.geolocationPosition;
                        if (!this.knowLocation) {
                            this.geolocationOnce = this.geolocationPosition;
                           // console.log('First position: ', this.geolocationOnce.coords);
                            this.knowLocation = true;
                        }
                    }
                }
            }
        });


    }
    public getObjectsTrip(tripId) {
        this.apiService.getObjectsTrip(tripId).subscribe(
            (res: any) => {
                this.places = res.data;
            },
            err => console.log(err), // error
            () => {
                this.generateWaypoints();
                this.activePoint = this.places[0];
            }
        );
    }

    public getTripData(tripId) {
        this.apiService.getTripData(tripId).subscribe(
            (res: any) => {
                this.tripData = res.data;
            },
            err => console.log(err), // error
            () => {

            }
        );
    }
    public hideRouteToStart() {
        this.isRouteVisible = false;
    }
    public showRouteToStart() {
        this.knowLocation = false;
        this.isRouteVisible = true;
    }
    public playAudio() {
        const nativeAudio = this.objectAudio.nativeElement;
        if (nativeAudio.paused) {
            nativeAudio.currentTime = 0;
            nativeAudio.play();
            this.audioPlaying = true;
        } else {
            nativeAudio.pause();
            this.audioPlaying = false;
        }
    }
    public checkDevice() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        console.log(this.deviceInfo);
        this.isMobile = this.deviceInfo.os;
        this.isDevice = this.deviceInfo.device;
        if ((this.isMobile.indexOf('windows-phone') >= 0)
        || (this.isMobile.indexOf('android') >= 0)
        || (this.isDevice.indexOf('iphone') >= 0)) {
            this.isMobileDevice = true;
            console.log(this.isMobileDevice);
        } else {
          this.isMobileDevice = false;
          console.log(this.isMobileDevice);
        }
      }

      public hideQuestion() {

      }

      public showQuestion() {
      }

      public countScore() {
        return this.questionsService.countScore(this.tripId);
      }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/trip-map/trip-map.component.ts